import DispatchConstants from '@common/constants/DispatchConstants';
import { UserInitStateInterface } from '../types';
import { REQUEST_GET_USER_ADDRESS } from '@rental-manager/constants/ActionConstants';

const initState = (): UserInitStateInterface => ({
  applicationsEnabled: false,
  paymentsAccessAllowed: false,
  userToken: '',
  email: '',
  summary: {
    activeListingCount: 0,
    totalListingCount: 0,
  },
  isMultifamilyCustomer: false,
  isSingleFamilyEnterpriseCustomer: false,
  originalServerSideRequestCookies: '',
  apiResponseServerSideRequestCookies: [],
  features: {},
  loggedIn: false,
  isUserBlocked: false,
  hasStrongAuthentication: false,
  roles: [],
  isTwoFactorEnabled: false,
  isTwoFactorAuthenticated: false,
  impersonatorUserToken: '',
  impersonatorEmail: '',
  hasAccess: false,
  sessionExpirationDate: 0,
  userAddress: {},
});

const user = (state: UserInitStateInterface = initState(), action: any = {}): UserInitStateInterface => {
  const { type, payload } = action;
  switch (type) {
    case DispatchConstants.UPDATE_USER_INFO:
      return { ...state, ...payload };
    case REQUEST_GET_USER_ADDRESS.SUCCESS:
      return {
        ...state,
        userAddress: payload.data,
      };
    default:
      return state;
  }
};

export default user;
